import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postStatut } from "./ServiceStatut";
import { useTranslation } from "react-i18next";
export default function AddStatut() {
 const { t } = useTranslation();
  const navigate = useNavigate();

  const [data, setData] = useState({
    statut: "",
    statutArab: "",
    statutAng: "",
  });

  const [errorMessage, setErrorMessage] = useState({});

  // Gestion des champs
  const onInputchange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  // Enregistrement
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await postStatut(data);
  
      toast.success(t("statut.saveSuccess"), {
         position: "bottom-right",
        autoClose: 2000,
      });

      setData({
        statut: "",
        statutArab: "",
        statutAng: "",
      });

      setErrorMessage({});

      navigate("/liststatut");

    } catch (error) {
        //console.log("ERREUR COMPLETE");
        //console.log(error.response);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {

        const errorArray = error.response.data.errors;

        // Construction du toast
        const formattedErrors = errorArray.map((err, index) => {

          const msg =
            err.indexOf(":") > -1
              ? err.split(":")[1]
              : err;

          return (
            <li key={index} className="list-group-item">
              {msg}
            </li>
          );
        });

        toast.error(
          <div style={{ width: "18rem" }}>
            <div className="card-header text-danger">
              <h5 className="card-title">
                {t("common.validationErrors")}
              </h5>
            </div>

            <div className="card-body">
              <ul className="list-group list-group-flush">
                {formattedErrors}
              </ul>
            </div>
          </div>,
          {
            position: "bottom-right",
            autoClose: 4000,
          }
        );

        const errorObject = {};

        errorArray.forEach((err) => {

          if (err.indexOf(":") > -1) {

            const [field, message] = err.split(":");

            errorObject[field.trim()] = message.trim();
          }
        });

        setErrorMessage(errorObject);

      } else {

        toast.error("Erreur lors de l'enregistrement");

        console.error(error);
      }
    }
  };

  return (
    <div
      className="div-width"
      style={{ marginTop: "6rem" }}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-5">

          <li className="breadcrumb-item">
            <i className="fa-solid fa-house"></i>

            <Link
              className="mx-2"
              to="/"
            >
               {t("menu.home")}
            </Link>
          </li>

          <li className="breadcrumb-item">
            <Link
              className="mx-2"
              to="/Liststatut"
            >
              {t("statut.titre")}
            </Link>
          </li>

          <li className="breadcrumb-item active">
            {t("statut.new")}
          </li>

        </ol>
      </nav>

      <div className="table-container">

        <div className="title div-responsive d-flex text-white justify-content-center align-items-center">
          <i className="fa-solid fa-folder-plus fa-2xl"></i>
        </div>

        <div className="border shadow rounded-2 p-3">

          <h4 className="ajst-titre mb-4">
            {t("statut.titre")}
          </h4>

          <form onSubmit={onSubmit}>

            <div className="row justify-content-center">

              <div className="col-md-6">


                {/* Activité FR */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.french")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="statut"
                    value={data.statut}
                    onChange={onInputchange}
                  />

                  {errorMessage.statut && (
                    <div className="text-danger mt-1">
                      {errorMessage.statut}
                    </div>
                  )}

                </div>

                {/* Activité {t("common.arabic")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.arabic")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="statutArab"
                    value={data.statutArab}
                    onChange={onInputchange}
                    dir="rtl"
                  />

                  {errorMessage.statutArab && (
                    <div className="text-danger mt-1">
                      {errorMessage.statutArab}
                    </div>
                  )}

                </div>

                {/* Activité {t("common.english")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.english")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="statutAng"
                    value={data.statutAng}
                    onChange={onInputchange}
                  />

                  {errorMessage.statutAng && (
                    <div className="text-danger mt-1">
                      {errorMessage.statutAng}
                    </div>
                  )}

                </div>

              </div>

            </div>

            <div className="text-center mt-4">

              <button
                type="submit"
                className="btn btn-outline-primary"
              >
                {t("button.save")}
              </button>

              <Link
                to="/Liststatut"
                className="btn btn-outline-success mx-2"
              >
                {t("button.close")}
              </Link>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}